import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useDrodModel } from "../drodModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { IDrodDetail } from "../drodTypes";
import { momentFormat } from "@/utils/utils";


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg, loading,
        loadData, setSelectedRowKeys,
    } = useDrodModel();
    const { getTreeNodeName } = useDictModel(() => []);

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<IDrodDetail> = [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '退税单据号',
            width: 160,
            dataIndex: 'code',
            fixed: "left",
        }, {
            title: '外贸合同号',
            width: 120,
            dataIndex: 'saleRealCode',
        }, {
            title: '状态',
            width: 160,
            dataIndex: 'status',
            render: text => getTreeNodeName(text)
        }, {
            title: '客户名称',
            width: 160,
            dataIndex: 'customerName',
        }, {
            title: '是否完成退税',
            width: 100,
            dataIndex: "isDrawback",
            render: (text) => text === 0 ? '是' : '否'
        }, {
            title: '退税日期',
            width: 180,
            dataIndex: "drawbackTime",
            render: text => momentFormat(text, "YYYY-MM-DD")
        }, {
            title: '退税金额',
            width: 180,
            dataIndex: "drawbackAmount"
        }, {
            title: '提交单据日期',
            width: 120,
            dataIndex: 'createTime',
            render: text => momentFormat(text, "YYYY-MM-DD")
        }, {
            title: '备注',
            width: 160,
            ellipsis: true,
            dataIndex: 'note',
        },
    ];


    //点击行选高亮
    const onRow = (id: string) => {
        let findIndex = selectedRowKeys.indexOf(id);
        let newSelectedRowKeys = [...selectedRowKeys];
        if (findIndex === -1) {
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            newSelectedRowKeys.splice(findIndex, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };

    return (
        <Table
            rowKey={record => record.id}
            loading={loading}
            rowSelection={{
                //全部选中时  (存string[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    let changeRowId = changeRows.map(item => item.id);
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRowId])
                        : setSelectedRowKeys((origin) => origin.filter(item => changeRowId.indexOf(item) < 0));
                },
                onSelect: (record) => onRow(record.id),
                selectedRowKeys: selectedRowKeys
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                position: ["bottomCenter"],
                showTotal: () => `共${pgCfg.total}条`,
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record.id),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record.id]);
                }
            })}
            scroll={{ x: 'max-content', y: "calc(100vh - 360px)" }}
        />
    )
}
